import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableDataTableStyles } from "./DataTable";

export function DataTableAASHTOFooter({ item, total, utilization }) {
  const { t } = useTranslation("translation");
  let decimalSeparator = i18n.resolvedLanguage === "de-DE" ? "," : ".";
  let thousandSeparator = i18n.resolvedLanguage === "de-DE" ? "." : ",";
  return (
    <>
      <View style={tableDataTableStyles.row}>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        {/* Total */}
        <Text style={tableDataTableStyles.title}>{t("aashto.inner.Total")}</Text>
        <Text style={tableDataTableStyles.title}>
          <NumberFormatTextPDF
            value={Number(item.tableTotal.current)}
            decimalScale={2}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
          />
        </Text>
      </View>
      <View style={tableDataTableStyles.row}>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        <Text style={tableDataTableStyles.title}></Text>
        {/* Utilization */}
        <Text style={tableDataTableStyles.title}>{t("aashto.inner.Utilization")}</Text>
        <Text style={tableDataTableStyles.title}>
          <NumberFormatTextPDF
            value={item.tableUtilization}
            decimalScale={2}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
          />
        </Text>
      </View>
    </>
  );
}
